'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          baseURL = _props.baseURL,
          provider = _props.provider,
          clientID = _props.clientID,
          redirectURL = _props.redirectURL;

      var redirectURI = location.protocol + '//' + location.host + '/' + redirectURL;
      window.location = baseURL + 'auth/ExternalLogin?provider=' + provider + '&response_type=token&client_id=' + clientID + '&redirect_uri=' + redirectURI;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', null);
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.propTypes = {
  baseURL: _react2.default.PropTypes.string.isRequired,
  provider: _react2.default.PropTypes.oneOf(['Google', 'Facebook', 'Twitter']).isRequired,
  clientID: _react2.default.PropTypes.string.isRequired,
  redirectURL: _react2.default.PropTypes.string.isRequired
};
_class.defaultProps = {
  baseURL: process.env.baseURL,
  provider: process.env.auth.provider,
  clientID: process.env.auth.clientID,
  redirectURL: process.env.auth.redirectURL
};
exports.default = _class;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/Auth/ExternalAuth/ExternalAuth.js
 ** module id = 483
 ** module chunks = 0
 **/